import React, { useEffect } from 'react';
import { Button, Form, Input, Select } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getBusinessIReferAction, inviteReferrerAction } from '../../actions/refer';
import { useSelector } from 'react-redux';
import Header from '@components/Comman/Header';
import { SendOutlined, UploadOutlined } from '@ant-design/icons';
import './index.css'
import CustomPhoneNumber from '@components/Comman/CustomPhoneNumber/CustomPhoneNumber';

const InviteReferrer = ({ isView = false }) => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const userD = useSelector((state: any) => state?.Auth?.user);
    const businessIReferList = useSelector((state: any) => state?.Business?.businessIReferList);
    const userData = userD?.user || userD?.data;
    let stateData = location?.state;
    isView = stateData?.isView;


    useEffect(()=> {
      dispatch(getBusinessIReferAction({ limit: 1000 }, ()=> {}));

    }, [userData])


  let modifiedBusinessReferList = businessIReferList?.map((item: any) => {
    return {
      value: item?.business?.BusinessDetails?.id,
      label: item?.business?.BusinessDetails?.businessName || item?.business?.businessDetails?.businessName,
    }
  });

  // ********* businesses refer list for business ***************** //
  userData?.roleId === 2 && 
  modifiedBusinessReferList.push({
    label:  userData?.businessDetails?.businessName || userData?.companyName,
    value: userData?.businessDetails?.id
  })

  useEffect(() => {
          if (modifiedBusinessReferList.length > 0) {
            const defaultBusinessId =
              userData?.businessDetails?.id ||
              modifiedBusinessReferList[0]?.value;

            form.setFieldsValue({
              businessId: defaultBusinessId,
    });
  }
}, [userData, modifiedBusinessReferList]);

    const handleBusinessChange = (value: string) => {
    if(businessIReferList?.length) {
        businessIReferList?.find((item: any) => {

            if(item?.senderCode === value) {
                return item
            } else if(value === userData?.businessCode) {

                let bussinessD:any = { ...userData};
                bussinessD.senderCode = userData?.businessCode
                return bussinessD
            }
        })
    } else {
        let bussinessD: any = { ...userData };
        bussinessD.senderCode = userData?.businessCode
    }
  };

    const onFinish = (values: any) => {
        dispatch(
            inviteReferrerAction(values, (resp: any) => {
                if (resp) {
                  userData?.roleId !== 3 && navigate('/my-referrers');
                }
            })
        );
    };

    const onFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
        // You can also display an error message to the user here
    };

    return (
      <div>
        <Header pagTitle="Invite A Referrer" />
        <div className='contentBody'>
          <div className="bodycard">
            <div className="bodycardheading d-flex csv-header">
              <div>
                <div className="mobileView buttonsvgs" onClick={()=> navigate(-1)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <rect
                      x="0.4"
                      y="1.18168"
                      width="23.2"
                      height="23.2"
                      rx="11.6"
                      stroke="#F47523"
                      strokeWidth="0.8"
                    />
                    <path
                      d="M14 8.78168L10 12.7817L14 16.7817"
                      stroke="#F47523"
                      strokeWidth="1.25"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
                Invite A Referrer
              </div>
              {
                userData?.roleId === 2 &&
                       <div>
                <button className='btn btn-primary' onClick={()=> navigate('/upload-referrer')} type='button'> Upload Referrer <UploadOutlined /></button>
              </div>
              }
       
            </div>
            <div className="cardContentbody">
              <Form
                className="formControl"
                layout="vertical"
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFailed}
              >
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <Form.Item
                      className="formControlDesign"
                      label="Business Name"
                      name="businessId"
                      rules={[
                        {
                          required: true,
                          message: 'Please select business!',
                        }
                      ]}
                    >
                      <Select
                        className="searchselects"
                        disabled={isView ? true : false} // Ensure disabled is a boolean value
                        placeholder="Business Name"
                        onChange={(value) =>
                          handleBusinessChange(value)
                        } // Simplify the onChange handler
                      >
                        {modifiedBusinessReferList?.map((item: any, index: number) => {
                          return (
                            <Select.Option key={index} value={item.value}>
                              {item.label}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-sm-12">
                    <Form.Item
                      className="formControlDesign"
                      label="First Name"
                      name="firstName"
                      rules={[{ required: true, message: 'Please input your First Name!' }]}
                    >
                      <Input placeholder='First Name' />
                    </Form.Item>
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <Form.Item
                      className="formControlDesign"
                      label="Last Name"
                      name="lastName"
                      rules={[{ required: true, message: 'Please input your Last Name!' }]}
                    >
                      <Input placeholder='Last Name' />
                    </Form.Item>
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <Form.Item
                      className="formControlDesign"
                      label="Email"
                      name="email"
                      rules={[{ required: true, type: 'email', message: 'Please input a valid email!' }]}
                    >
                      <Input placeholder='Email' />
                    </Form.Item>
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <CustomPhoneNumber isRequired={true} label="Contact Number" name="mobileNumber" />
                  </div>
                 
                  <div className="col-lg-12 mt-15">
                    <div className="text-end btn-groups-Forms">
                      <button className="btn btn-outline-primary" onClick={() => navigate('/dashboard')}>
                        Cancel
                      </button>
                      <Button className="btn btn-primary" type='primary' onClick={() => form.submit()}>
                        Send Invite <SendOutlined />
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
};

export default InviteReferrer;
